import { useRef, useState } from "react";
import {
  Center,
  Image as ChakraImage,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
} from "@chakra-ui/react";
import { Empty } from "components/empty";
import type { Image } from "types/image";
import { getHighestResolutionImageSource } from "utils/images";

type MobileImageGalleryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  images: Image[];
  emptyMessage: string;
};
export function MobileImageGalleryModal({
  isOpen,
  onClose,
  images,
  emptyMessage,
}: MobileImageGalleryModalProps) {
  const [currentModalImage, setCurrentModalImage] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  function handleScroll() {
    const container = scrollRef.current;
    if (!container) return;

    const containerWidth = container.offsetWidth;
    const scrollLeft = container.scrollLeft;

    const imagesWidth = container.scrollWidth;
    const imageWidth = imagesWidth / images.length;

    const currentIndex = Math.floor(
      (scrollLeft + containerWidth / 2) / imageWidth,
    );

    if (currentIndex !== currentModalImage) {
      setCurrentModalImage(currentIndex);
    }
  }

  function handleClose() {
    onClose();
    setCurrentModalImage(0);
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size={"full"}>
      <ModalContent>
        <ModalHeader
          fontWeight={400}
          borderBottom={"1px solid"}
          borderColor={"gray.200"}
        >
          <Center h={"40px"}>
            {`${currentModalImage + 1}/${images?.length}`}
          </Center>
        </ModalHeader>

        <ModalCloseButton />

        <ModalBody
          h={"100%"}
          p={0}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          {images?.length > 0 ? (
            <HStack
              ref={scrollRef}
              gap={6}
              w={"100%"}
              overflowX={"scroll"}
              onScroll={handleScroll}
              scrollSnapType={"x mandatory"}
            >
              {images?.map((image, idx) => (
                <ChakraImage
                  key={image.sources[0].url}
                  w={"100%"}
                  fit={"cover"}
                  src={getHighestResolutionImageSource(image)?.url}
                  alt={`Listing image #${idx + 1}`}
                  scrollSnapAlign={"start"}
                />
              ))}
            </HStack>
          ) : (
            <Empty emptyMessage={emptyMessage} />
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
